import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit1-introduction',
  templateUrl: './unit1-introduction.component.html',
  styleUrls: ['./unit1-introduction.component.css']
})
export class Unit1IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
